export const API_BASE_URL = 'https://i-foodie.dave-davehua.workers.dev';

export const API_ENDPOINTS = {
  POSTS: `${API_BASE_URL}/api/posts`,
  USERS: `${API_BASE_URL}/api/users`,
  SEARCH: `${API_BASE_URL}/api/search`,
  YUM_POST: `${API_BASE_URL}/api/posts/yum`,
  // Follow endpoints
  followUser: (userId: string) => `${API_BASE_URL}/api/users/${userId}/follow`,
  getUserFollowers: (userId: string) => `${API_BASE_URL}/api/users/${userId}/followers`,
  getUserFollowing: (userId: string) => `${API_BASE_URL}/api/users/${userId}/following`,
  // TODO: Add endpoint to get user profile with follow status/counts if needed
  // Example: getUserProfile: (username: string) => `${API_BASE_URL}/api/users/profile/u/${username}`,
  // We might need to enhance the existing user profile endpoint to return follow data
  // Add other endpoints here as needed
}; 